import { AbstractField } from './abstract-field.component';
import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

const customValueProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => PhoneFieldComponent),
  multi: true
};

@Component({
  selector: 'phone-field',
  inputs: [...AbstractField.inputs, 'type', 'maxLength', 'minLength', 'name'],
  outputs: [...AbstractField.outputs],
  // template parser will yield out [Object object] as parameters when leveraging {} so we have to handle
  // it's limitations. If you know of a way to circumvent them, please share.
  template: `
    <div
      [floatingLabel]="model"
      [focus]="focused"
      [ngClass]="
        (showValidation || inp.dirty || inp.touched) &&
        required &&
        (!model || model == '' || !inp.valid || error)
          ? 'validation-failed'
          : 'validation-success'
      "
    >
      <label class="phone-label" for="FIELD={{ id }}">{{
        label + (required ? '*' : '')
      }}</label>
      <input
        [autocomplete]="autocomplete"
        [attr.name]="name || autocomplete"
        id="FIELD-{{ id }}"
        [(ngModel)]="model"
        ng2TelInput
        (intlTelInputObject)="telInputObject($event)"
        (hasError)="handleError($event)"
        (countryChange)="onCountryChange($event)"
        placeholder=""
        class="form-control"
        (focus)="focused = true"
        (blur)="onBlur($event)"
        (ngModelChange)="onChange($event)"
        [disabled]="disabled"
        [required]="required"
        #inp="ngModel"
        [type]="type"
        [email]="type === 'email'"
        [attr.maxLength]="maxLength ? maxLength : null"
        [attr.minLength]="minLength ? minLength : null"
        (keypress)="handleKeyPress($event)"
      />
    </div>
  `,
  providers: [customValueProvider]
})
export class PhoneFieldComponent extends AbstractField {
  _country: string;
  type = 'tel';
  maxLength = 0;
  minLength = 0;
  name = '';
  error = false;
  telObj;
  checkNum: any;
  @Input() model: any;
  @ViewChild('inp', { read: ElementRef, static: true }) inp: ElementRef;
  @Output() countryChange = new EventEmitter<any>();
  @Input()
  set country(country: string) {
    this._country = country;
    if (country && this.telObj) {
      this.telObj.setCountry(country);
    }
  }
  get country() {
    return this._country;
  }
  constructor() {
    super();
  }
  handleKeyPress($event) {
    const pattern = /[0-9\-\(\)\ ]/;
    const inputChar = $event.key;

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      $event.preventDefault();
      return false;
    }
  }
  telInputObject(obj) {
    this.telObj = obj;
  }
  setMask() {
    const msk = (<any>window)
      .jQuery(this.inp.nativeElement)
      .attr('placeholder')
      .replace(/\d/g, 9);
    (<any>window).jQuery(this.inp.nativeElement).inputmask(msk);
  }
  onCountryChange(evt) {
    this.countryChange.emit(evt);
  }
  handleError($event) {
    // I don't know what's up with this telInput component, but everytime this handlError
    // event is triggered you get a 'false' when there is a problem,
    // and a true when the data is valid
    this.error = $event === false;
  }
}
